/**
 * coupon api
 * 优惠券 https://doc.apipost.net/docs/detail/4810535f00a9000?target_id=48144e0ff8a1000
 */
import httpRequest from "@/utils/request";
import { CouponParams } from "./types";

/**
 * 创建优惠卷
 * @param param
 * @returns
 */
const createCoupon = (param: CouponParams) => {
    return httpRequest({
        url: `/coupon/createCoupon`,
        method: "post",
        data: param,
    });
};

/**
 * 医生优惠卷列表
 * @param param doctorUserId
 * @returns
 */
const getDoctorCouponList = (param: { id: string }) => {
    return httpRequest({
        url: `/coupon/doctorCouponList/${param.id}`,
        method: "post",
        data: param,
    });
};

/**
 * 修改优惠卷
 * @param param
 * @returns
 */
const updateCoupon = (param: CouponParams) => {
    return httpRequest({
        url: `/coupon/updateCoupon`,
        method: "post",
        data: param,
    });
};

/**
 * 删除优惠卷
 * @param param
 * @returns
 */
const deleteCoupon = (param: { couponId: number }) => {
    return httpRequest({
        url: `/coupon/deleteCoupon/${param.couponId}`,
        method: "delete",
        params: param,
    });
};

/**
 * 购买优惠卷
 * @param param
 * @returns
 */
const buyCoupon = (param: { couponId: number }) => {
    return httpRequest({
        url: `/coupon/buyCoupon`,
        method: "post",
        data: param,
    });
};

/**
 * 用户优惠卷列表
 * @param param
 * @returns
 */
const getUserCouponList = (param?: { userId?: string }) => {
    return httpRequest({
        url: `/coupon/userCouponList`,
        method: "get",
        params: param,
    });
};

/**
 * 当前优惠卷的购买人列表
 * @param param
 * @returns
 */
const getCouponUserList = (param: { couponId?: string }) => {
    return httpRequest({
        url: `/coupon/couponByUserList/${param.couponId}`,
        method: "get",
        params: param,
    });
};

/**
 * 根据id获取优惠券详情
 * @param param
 * @returns
 */
const getCouponDetail = (param: { couponId: number }) => {
    return httpRequest({
        url: `/coupon/couponById/${param.couponId}`,
        method: "get",
        params: param,
    });
};

/**
 * 上下架优惠券
 * @param param
 * @returns
 */
const listOrRemoveCoupon = (param: { couponId: number; status?: number }) => {
    return httpRequest({
        url: `/coupon/listOrRemoveCoupon`,
        method: "get",
        params: param,
    });
};

export default {
    createCoupon,
    getDoctorCouponList,
    updateCoupon,
    deleteCoupon,
    buyCoupon,
    getUserCouponList,
    getCouponUserList,
    getCouponDetail,
    listOrRemoveCoupon,
};
